// TableRefreshContext.tsx
import React, { createContext, useContext, useCallback, useState } from "react";

const TableRefreshContext = createContext<any>(null);

export const TableRefreshProvider = ({ children }: any) => {
  const [refreshKey, setRefreshKey] = useState<number>(0);

  const triggerRefresh = useCallback(() => {
    setRefreshKey((prev) => prev + 1);
  }, []);

  return (
    <TableRefreshContext.Provider value={{ refreshKey, triggerRefresh }}>
      {children}
    </TableRefreshContext.Provider>
  );
};

export const useTableRefresh = () => useContext(TableRefreshContext);